<ExpandablePanel 
  title="La base de datos"
  description="Indica con que base de datos deseas que interactue el conector"
  bind:expanded={expanded}>

  <div slot="resume">
    <Text nm color="body">
      Se conectará a la base de datos <b>{db.url}</b>        
    </Text>
  </div>

  <div slot="content">
    <Panel mt="md">
      <Select bg="white" bind:value={db.engine} options={engines} mr="xs" w="11" />
      <Input bg="white" bind:value={db.host} size="16" />
      <Input bg="white" bind:value={db.port} size="6" />
      <br>
      <Text sm color="body" line="ample">
        Motor, Servidor y Puerto (si corresponde) al cual se conectará
      </Text>
    </Panel>
    
    <Panel mt="md">
      <Input bg="white" bind:value={db.user} size="18"/>
      <Input bg="white" type="password" bind:value={db.passw} size="16"/>
      <br>
      <Text sm color="body" line="ample">Usuario y contraseña</Text>
    </Panel>

    <!-- <Panel mt="md">
      <Text sm>
        Conectará a la base de datos <b>{db.url}</b>
      </Text>
    </Panel> -->
  </div>

</ExpandablePanel>


<script>
  import { Panel, Input, Select, Heading, Label, Text, Button, Icon } from 'svelte-stylo';
  import ExpandablePanel from '@/components/panels/ExpandablePanel.svelte'

  export let db = {};
 
  let expanded = true;

  const engines = [
    { value: 'postgres', text: 'Postgres'},
    { value: 'oracle', text: 'Oracle'},
    { value: 'mssql', text: 'MS Sql'},
    { value: 'mariadb', text: 'Maria Db'},
    { value: 'mysql', text: 'MySQL'},
    { value: 'sqlite', text: 'SQLite'},
  ]

  // dialect+driver://username:password@host:port/database
  $: db.url = `${db.engine}://${db.user}:${db.passw}@${db.host}`
              // format port as ':1234'
              +(db.port ? ':'+db.port : '');
</script>